module.exports = __webpack_public_path__ + "images/category_lp/retro_game/store_images/3_9a91eb1d485236263a3ed1e99099e3bd.png";